import { memo, useContext } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { OEContext } from '@aytm/app/stats/page/comments'

import { changeResponseCommentStatus } from '@aytm/app/stats/page/comments/actions'

import Popup from '@aytm/lib/rfd-ui/components/basic/popup'
import NotificationPopup from '@aytm/app/stats/page/comments/comments/components/Response/NotificationPopup'

import style from '@aytm/app/stats/page/comments/comments/styles/Response.module.scss'

const Kudos = memo(({ responseId, kudosConfirm, setKudosConfirm, onCloseNotification, popupNotificationsDisabled }) => {
  const { dispatchCommentStatuses, commentStatusesState, searchState } = useContext(OEContext)
  const { CSRF, isAdmin } = searchState
  const kudosStatus = commentStatusesState.kudos[responseId]

  const onToggleKudosResponse = async (responseId, type) => {
    await changeResponseCommentStatus({
      type,
      responseId,
      reason: null,
      scope: 'kudos',
      commentStatusesState,
      dispatchCommentStatuses,
      CSRF
    })
  }

  const onToggleKudos = async type => {
    if ('unkudos' == type) {
      await onToggleKudosResponse(responseId, type)
      setKudosConfirm('')
    } else {
      setKudosConfirm(type)
    }
  }

  const onConfirmToggleKudos = async () => {
    await onToggleKudosResponse(responseId, kudosConfirm)
    setKudosConfirm('')
  }

  const onCancelToggleKudos = () => {
    setKudosConfirm('')
  }

  switch (true) {
    case 'true' == kudosStatus:
    case 'revertable' == kudosStatus:
      return (
        <NotificationPopup
          type="kudos"
          action="unkudos"
          status={kudosStatus}
          disabled={popupNotificationsDisabled['unkudos']}
          onClosePopup={onCloseNotification}
        >
          <span
            className={classNames(style['response-header-kudos'], {
              [style['kudos-revertable']]: 'revertable' == kudosStatus
            })}
            onClick={'revertable' == kudosStatus ? onToggleKudos.bind(this, 'unkudos') : undefined}
          >
            <em>Kudos! </em> <i className="icon-aytmfd-heart" />
          </span>
        </NotificationPopup>
      )
    case 'loading' == kudosStatus:
      return <i className="icon-aytmfd-refresh-v2 aytmfd-spin" />
    case 'object' == typeof kudosStatus && 'error' == kudosStatus.type:
      return (
        <Popup
          width="215px"
          direction="topleft"
          popupOffset={15}
          portal
          show={null !== kudosStatus.message}
          hideOtherPopupsOnShow
          content={() => <div className={style['response-header-notification-text']}>{kudosStatus.message}</div>}
        >
          <span className={style['kudos']}>Error</span>
        </Popup>
      )
    default:
      switch (true) {
        case Boolean(kudosConfirm): {
          return (
            <div className={style['response-header-confirmation']}>
              <span
                className={style['response-header-confirmation-button']}
                onClick={onCancelToggleKudos}
                rel="noreferrer"
              >
                Cancel
              </span>
              <span
                className={style['response-header-confirmation-button']}
                onClick={onConfirmToggleKudos}
                rel="noreferrer"
              >
                <span className={style['kudos-confirm']}>Give Kudos</span>
                <i className="icon-aytmfd-heart-empty" />
              </span>
            </div>
          )
        }
        default:
          return (
            <div
              className={classNames(style['response-header-kudos'], {
                [style['has-notification']]:
                  !popupNotificationsDisabled[['true', 'revertable'].includes(kudosStatus) ? 'unkudos' : 'kudos'] &&
                  !isAdmin
              })}
            >
              <NotificationPopup
                type="kudos"
                action="kudos"
                status="no"
                disabled={popupNotificationsDisabled['kudos'] || isAdmin}
                onClosePopup={onCloseNotification}
              >
                <span className={style['non-kudos']} onClick={onToggleKudos.bind(this, 'kudos')}>
                  <em>Give Kudos?</em> <i className="icon-aytmfd-heart-empty" />
                </span>
              </NotificationPopup>
            </div>
          )
      }
  }
})

Kudos.propTypes = {
  popupNotificationsDisabled: PropTypes.object,
  onCloseNotification: PropTypes.func,
  response: PropTypes.object,
  responseId: PropTypes.number,
  kudosConfirm: PropTypes.string,
  setKudosConfirm: PropTypes.func,
  onToggleKudosResponse: PropTypes.func
}

Kudos.displayName = 'Kudos'

export default Kudos
